module.exports = __webpack_public_path__ + "img/logo.4f4732a2.png";